import gql from 'graphql-tag';

const LIST_CAMPAIGNORDERS_CONNECTION = gql`
  query campaignOrdersConnection(
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderOrderByInput
    $where: CampaignOrderWhereInput!
    $currentUsersOrg: ID!
  ) {
    campaignOrdersConnection(first: $first, skip: $skip, orderBy: $orderBy, where: $where) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          status
          type
          signUpCampaign
          startDate
          endDate
          attributionWindow
          budget
          cpm
          advertiser {
            id
            CPAcronym
            level
            name
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
          IONumber
          productCode
          aggregateData {
            id
            overallData {
              id
              aggEvents
              aggCost
              aggTotalCost
              aggImpressions
              aggClicks
              aggVWI
              totalObservations
              signupsOverallData
            }
            dayPacingData {
              id
              aggEvents
              aggCost
              aggTotalCost
              aggImpressions
              aggClicks
              aggVWI
              totalObservations
            }
            byDate
            topCreatives
            topPublishers
          }
          pacingData {
            id
            pace
            impressionsLeft
            expectedImpressions
            roas
            ctr
            dailyAvgImpressions
            dailyAvgImpressionsLeft
            daysIntoFlight
            daysLeft
            paceYesterday
            impressionsYesterday
          }
          createdAt
          updatedAt
          campaigns(first: 30) {
            id
            cpm
            data
          }
          attributionTargets {
            id
          }
          transactionTarget
          transactionsConfig {
            id
            appId
            cart
            traffId
            gtmAccess
            gtmStatus
            tracksBasketItems
          }
          sessionConfig {
            id
            isSession
            appId
            locationId
            cart
          }
          isRequestChange
          orgs(first: 25, where: { parentOrg_some: { id: $currentUsersOrg } }) {
            id
            name
            rpm
            level
          }
          renewalStatus
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrdersConnection(first: 5000, where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default LIST_CAMPAIGNORDERS_CONNECTION;
